export const LogoMark = ({ className = "h-12 w-auto" }) => (
  <img src="/img/logo.png" alt="Warrior Towing & Recovery LLC logo" className={`${className} object-contain`} />
);

export const Logo = () => (
  <span className="flex items-center">
    <LogoMark className="h-14 w-auto sm:h-16" />
  </span>
);
